module.exports = __webpack_public_path__ + "static/media/231-2319913_roku-channel-black-and-white-hd-png-download.46e00004.webp";